import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';

import { ApplicationService } from '@core/services/application.service';
import { ApplicationSettings } from '@core/models/application-settings';
import { Router } from '@angular/router';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	host: { 'class': 'd-block' },
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {

	settings: ApplicationSettings;

	constructor(private applicationService: ApplicationService,
		private oktaAuthService: OktaAuthService,
		private changeDetectorRef: ChangeDetectorRef,
		private router: Router) {

		this.settings = this.applicationService.getSettings();
	}

	ngOnInit() {

		this.applicationService.onUpdateSettings().subscribe((settings: ApplicationSettings) => {

			this.settings = settings;
			this.changeDetectorRef.detectChanges();
		});
	}

	goBack() {

		window.history.back();
	}

	goToSettings() {

		this.router.navigate(['/settings']);
	}

	logout() {

		this.oktaAuthService.logout('/login');
	}
}
